/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterClaimsQueryDto
 */
export interface FilterClaimsQueryDto {
    /**
     * Filter by insured
     * @type {Array<string>}
     * @memberof FilterClaimsQueryDto
     */
    insureds?: Array<string>;
    /**
     * Filter by status
     * @type {Array<string>}
     * @memberof FilterClaimsQueryDto
     */
    statuses?: Array<FilterClaimsQueryDtoStatusesEnum>;
    /**
     * Filter by line of business
     * @type {Array<string>}
     * @memberof FilterClaimsQueryDto
     */
    lineOfBusiness?: Array<string>;
    /**
     * Filter by claims handler
     * @type {Array<string>}
     * @memberof FilterClaimsQueryDto
     */
    claimsHandler?: Array<string>;
    /**
     * Filter by reported date from
     * @type {Date}
     * @memberof FilterClaimsQueryDto
     */
    dateReportedFrom?: Date;
    /**
     * Filter by reported date to
     * @type {Date}
     * @memberof FilterClaimsQueryDto
     */
    dateReportedTo?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FilterClaimsQueryDto
     */
    includeInsured?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterClaimsQueryDto
     */
    includeClaimHandler?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilterClaimsQueryDto
     */
    includeBinderClaims?: boolean;
}


/**
 * @export
 */
export const FilterClaimsQueryDtoStatusesEnum = {
    PreCautionary: 'Pre-cautionary',
    Registered: 'Registered',
    InProgress: 'In-progress',
    Closed: 'Closed'
} as const;
export type FilterClaimsQueryDtoStatusesEnum = typeof FilterClaimsQueryDtoStatusesEnum[keyof typeof FilterClaimsQueryDtoStatusesEnum];


/**
 * Check if a given object implements the FilterClaimsQueryDto interface.
 */
export function instanceOfFilterClaimsQueryDto(value: object): value is FilterClaimsQueryDto {
    return true;
}

export function FilterClaimsQueryDtoFromJSON(json: any): FilterClaimsQueryDto {
    return FilterClaimsQueryDtoFromJSONTyped(json, false);
}

export function FilterClaimsQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterClaimsQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insureds': json['insureds'] == null ? undefined : json['insureds'],
        'statuses': json['statuses'] == null ? undefined : json['statuses'],
        'lineOfBusiness': json['lineOfBusiness'] == null ? undefined : json['lineOfBusiness'],
        'claimsHandler': json['claimsHandler'] == null ? undefined : json['claimsHandler'],
        'dateReportedFrom': json['dateReportedFrom'] == null ? undefined : (new Date(json['dateReportedFrom'])),
        'dateReportedTo': json['dateReportedTo'] == null ? undefined : (new Date(json['dateReportedTo'])),
        'includeInsured': json['includeInsured'] == null ? undefined : json['includeInsured'],
        'includeClaimHandler': json['includeClaimHandler'] == null ? undefined : json['includeClaimHandler'],
        'includeBinderClaims': json['includeBinderClaims'] == null ? undefined : json['includeBinderClaims'],
    };
}

export function FilterClaimsQueryDtoToJSON(json: any): FilterClaimsQueryDto {
    return FilterClaimsQueryDtoToJSONTyped(json, false);
}

export function FilterClaimsQueryDtoToJSONTyped(value?: FilterClaimsQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insureds': value['insureds'],
        'statuses': value['statuses'],
        'lineOfBusiness': value['lineOfBusiness'],
        'claimsHandler': value['claimsHandler'],
        'dateReportedFrom': value['dateReportedFrom'] == null ? undefined : ((value['dateReportedFrom']).toISOString()),
        'dateReportedTo': value['dateReportedTo'] == null ? undefined : ((value['dateReportedTo']).toISOString()),
        'includeInsured': value['includeInsured'],
        'includeClaimHandler': value['includeClaimHandler'],
        'includeBinderClaims': value['includeBinderClaims'],
    };
}

